/// Video 
var video = $("#bgvid");
var pause = $("#pause");

var cookiename = 'videopause';

if (video.length && pause.length) {
	
	initVideo();
	
    video.on("ended", function () {
        $(this).pause();
        $(this).addClass('stopfade');
        vidFade();
    });
    
    $("#pause").click(function () {
        video.toggleClass("stopfade");
        videoToggle();
		
    });
    $(document).on('open.zf.reveal', function() {
    	videoPause();
    });
    $(document).on('closed.zf.reveal', function() {
    	videoPlay();
    });
	
	function initVideo(){
		if(getCookie(cookiename) == 'pause'){
			videoPause();
		}else{
			videoPlay();
		}
	}
	
	function videoPause(){
		video.get(0).pause();
		video.data('isPaused',true);
		setCookie(cookiename,'pause');
		$("#pause").html("<i class='fa fa-play-circle' aria-hidden='true'></i>");
	}
	
	function videoPlay(){
		video.get(0).play();
		video.data('isPaused',false);
		setCookie(cookiename,'play');
		$("#pause").html("<i class='fa fa-pause-circle' aria-hidden='true'></i>");
	}
	
	function videoToggle(){
		var isVideoPaused = video.data('isPaused');
    	if (typeof isVideoPaused !== 'undefined') {
			if(isVideoPaused){
				videoPlay();
			}else{
				videoPause();
			}
		}
	}
	
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	
	function setCookie(cname, cvalue, exdays) {
		if(typeof exdays == 'undefined') exdays = 90;
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	
}